import { useEffect } from 'react';

import { CaptionText, H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';

import { Overlay } from '../Overlay';
import { getMyHubsFuturaMining } from '../Portfolio.actions';

import { FutureMiningItem } from './FutureMiningItem';

export const FutureMiningSummary = () => {
  const dispatch = useDispatch();

  const { futuraMining } = useAppSelector((state) => state.portfolio);

  const isAllActive = futuraMining?.orders?.some(
    (item: { isActive: boolean }) => item.isActive === true
  );

  useEffect(() => {
    dispatch(getMyHubsFuturaMining());
  }, [dispatch]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        dispatch(getMyHubsFuturaMining());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <Flexed column>
          <H3 mb='15' color={colors.primary900}>
            Futura Mining
          </H3>
          <a
            href='https://app.futura-mining.com/'
            target='_blank'
            rel='noreferrer'>
            https://app.futura-mining.com/
          </a>
        </Flexed>

        <Button negative disabled maxWidth='250px' maxWidthSM='100%'>
          ADD FUTURA MINING
        </Button>
      </Flexed>

      <div>
        {futuraMining?.orders?.map((item: any, index: number) => (
          <FutureMiningItem key={index} item={item} isAllActive={isAllActive} />
        ))}
      </div>
      {futuraMining?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
